var _defs, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDetalhes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #171954;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m39.96,50.34c-2.54,0-4.6-2.06-4.6-4.59v-11.11l-1.87.02h-.04c-1.79,0-3.26-1.44-3.29-3.24-.02-1.81,1.43-3.3,3.24-3.33l3.89-.05c2.57,0,4.63,2.06,4.63,4.59v11.13h2.13s0,0,.01,0c1.81,0,3.28,1.46,3.29,3.27,0,1.81-1.46,3.29-3.27,3.3h-4.12Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.97,
    cy: 22.41,
    r: 3.88
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDetalhes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DETALHES.ba9bbfe2a2510172e41ad21b2d61bb47.svg";